import React from "react";

function AmountPicker({ value, onChange,isInvalid }) {
  const preventScroll = (e) => e.target.blur();
  const preventArrowKeys = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  return (
    <input
      onWheel={preventScroll} // Disable mouse scroll
      onKeyDown={preventArrowKeys} // Disable keyboard arrow keys
      value={value}
      onChange={onChange}
      type="text"
      // placeholder="00.00"
      placeholder="0.00"
      className="bg-transparent text-black placeholder-gray-600 dark:text-dark-text dark:placeholder-gray-600 focus:outline-none w-full text-left text-2xl"
      style={{ color: isInvalid && value ? "red" : "" }} 
    />
  );
}

export default AmountPicker;
